import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAuthPortalUrl } from 'coreIndex';
import { logger } from 'utils/logger';
import './AuthOnlyRedirect.css';

/**
 * Redirects current path to the platform-auth origin so the user must sign in.
 */
export default function AuthOnlyRedirect() {
  const location = useLocation();
  useEffect(() => {
    let base = typeof getAuthPortalUrl === 'function' ? getAuthPortalUrl() : null;
    if (!base) {
      logger.error('APP', 'AuthOnlyRedirect: no AUTH_PORTAL_URL');
      return;
    }
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const port = typeof window !== 'undefined' ? window.location.port : '';
    const protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:';
    if ((hostname === 'localhost' || hostname === '127.0.0.1') && port === '5003' && base.includes('4003')) {
      base = `${protocol}//${hostname}:5004`;
    }
    const target = `${base.replace(/\/$/, '')}${location.pathname}${location.search || ''}`;
    window.location.replace(target);
  }, [location.pathname, location.search]);
  return (
    <div className="auth-only-redirect" role="status" aria-live="polite">
      <div className="auth-only-redirect__inner">
        <div className="auth-only-redirect__spinner" aria-hidden />
        <p className="auth-only-redirect__text">Redirecting to sign in…</p>
      </div>
    </div>
  );
}
